import { NgModule } from '@angular/core';
import { PaginationModule, SpinnerModule } from "@spartacus/storefront";
import { I18nModule, PageMetaResolver } from "@spartacus/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';
import { GenShippingAccountsResolver } from '../../resolvers/shipping-accounts.resolver';
import { GenShippingAccountsComponent } from './shipping-accounts.component';

@NgModule({
  declarations: [GenShippingAccountsComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    RouterModule,
    PaginationModule,
    I18nModule,
  ],
  providers: [{
      provide: PageMetaResolver,
      useExisting: GenShippingAccountsResolver,
      multi: true,
    }]
})
export class GenShippingAccountsModule { }
